import React, { Component } from 'react';
import { Card, Badge, Row, Col } from 'react-bootstrap';
import { GetText, ReplacePrefixUrl, ReplaceText } from '../../config/helper';
import DateTimeFormats from '../../config/date-time-format';
import NAimage from '../../img/pic-na.png';

import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

export default class HomeLP extends Component {

  constructor(props) {
    super(props);
    this.state = {
      id: '',
      title: '',
      image: '',
      link: '',
      memberStatus: localStorage.getItem('status')
    }
  }

  componentDidMount() {
    var content = this.props.value;
    var libItemEnrolled = (content.enrolled !== undefined)? content.enrolled : {};

    this.setState({
      id: content.id,
      title: ReplaceText(content.libraryTitle),
      image: (content.libraryPicture !== "" && content.libraryPicture !== undefined)? content.libraryPicture : NAimage,
      percentage: libItemEnrolled.completion !== undefined?  libItemEnrolled.completion : 0,
      lastmodule: libItemEnrolled.lastLesson !== undefined? libItemEnrolled.lastLesson : '',
      lastvisit:libItemEnrolled.lastVisit !== undefined? DateTimeFormats(libItemEnrolled.lastVisit._seconds,"date-long") : '',
      link: '/library/' + ReplacePrefixUrl(content.libraryTitle) + '/' + content.id
    });

  }

  render() { 
    return (
			<a href={this.state.link}>
        <Card className="library-card-lp">
          <Card.Img variant="top" src={this.state.image} alt={"Library " + this.state.title}/>
          <Card.Body>
            <Card.Title>{this.state.title}</Card.Title>
            <Row>
              <Col sm={8} className="d-flex align-items-center">
                  {this.state.percentage === 0? 
                    <Badge bg="danger" style={{ fontSize: '16px' }}>Not Started</Badge>
                  : 
                  <Card.Text>
                    {GetText() ? "Modul Terakhir:" : "Last Module:"}<br/>
                    {GetText() ? "Modul ": "Module "} {this.state.lastmodule}
                  </Card.Text>
                  }
              </Col>
              <Col sm={4}>
                <div className='circular-bar'>
                  <CircularProgressbar 
                    value={this.state.percentage} 
                    text={`${this.state.percentage}%`} 
                    styles={{
                      rotation: 0,
                      text: {
                        fontWeight: "bold", // Set the font weight here   // You can use string values like "bold", "normal", "lighter" or numeric values like "700"
                        fontSize: '26px',
                        fill: '#166fd4',
                      },
                      background: {
                        fill: '#3e98c7',
                      },
                      trail: {
                        stroke: '#d6d6d6',
                        strokeLinecap: 'butt',
                      },
                      path: {
                        stroke: `rgba(62, 152, 199, ${this.state.percentage / 100})`,
                        strokeLinecap: 'butt',
                        transition: 'stroke-dashoffset 0.5s ease 0s',
                      },
                    }}
                  />;
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </a>
    )
  }
}